import {
  Badge,
  Box,
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  makeStyles,
  withStyles,
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SyncIcon from '@material-ui/icons/Sync'
import classNames from 'classnames'

import { fetchDashboard, eraseDashboardFilters } from '../HomeActions'
import styles from '../../../resources/theme/global'
import { hasRole, renderRoute, renderRouteRole } from '../../../util/utils'

import Cards from './Cards'
import Filter from './Filters'
import colors from '../../../assets/colors'
import Chart from 'react-google-charts'
import PieChart from './PieChart'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import { fetchPlanDetails } from '../../subscription/SubscriptionActions'
import {
  mdiArrowTopRight,
  mdiChevronRight,
  mdiReceiptClockOutline,
} from '@mdi/js'
import Icon from '@mdi/react'

const useStyles = makeStyles({
  '@keyframes pulseAnimation': {
    '0%': {
      opacity: 1,
    },
    '50%': {
      opacity: 0.5,
    },
    '100%': {
      opacity: 1,
    },
  },
  chartBox: {
    width: '100%',
    border: `1px solid ${colors.graylight}`,
    borderRadius: '10px',
    padding: '24px',
  },
  chartBoxHeader: {
    fontSize: '20px',
    color: colors.primary,
    lineHeight: '20px',
  },
  teste: {
    border: '1px solid red',
  },
  overdueItensBtn: {
    borderRadius: '8px',
    color: colors.error,
    backgroundColor: colors.bgError,
    padding: '0 12px',
    height: '30px',
    margin: 0,
    fontSize: '14px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: colors.bgError,
      opacity: 0.8,
    },
    '&.Mui-disabled': {
      color: colors.sucess,
      backgroundColor: colors.bgSucess,
    },
  },
})

function Home(props) {
  const classes = useStyles()

  const filterStyles = filterStylesComponents()

  const refreshing = useSelector(state => state.dashboard.refreshing)
  const readyItems = useSelector(state => state.dashboard.readyCount)
  const readyItemsLaundry = useSelector(
    state => state.dashboard.readyLaundryCount
  )
  const overdueItems = useSelector(state => state.dashboard.overdueItemsCount)

  const permissionUser = useSelector(state => state.auth.permissionUser)
  const role = useSelector(state => state.auth.role) || {}

  const dispatch = useDispatch()

  useEffect(() => {
    if (!role?.length) return
    if (renderRouteRole(['administrador'], role)) return

    dispatch(fetchDashboard())
    dispatch(eraseDashboardFilters())

    return () => {
      dispatch(eraseDashboardFilters())
    }
  }, [role])

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Grid container justifyContent="space-between">
          <Grid item xs>
            <Typography
              variant="h4"
              style={{ fontSize: '20px' }}
              color={colors.primary}
            >
              Dashboard Itens
            </Typography>
          </Grid>

          <Grid item>
            <Grid container justifyContent="flex-end" spacing={2}>
              {!renderRouteRole(['administrador'], role) && (
                <Grid item>
                  <Button
                    component={Link}
                    className={classes.overdueItensBtn}
                    disabled={!overdueItems}
                    to="/details/overdue"
                  >
                    ITENS EM ATRASO
                    <Box
                      style={{
                        height: '100%',
                        marginLeft: '8px',
                        background: overdueItems ? colors.error : colors.sucess,
                        color: 'white',
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0 0 0 8px',
                        gap: '4px',
                      }}
                    >
                      {overdueItems || ''}
                      <Icon path={mdiChevronRight} size={1} />
                    </Box>
                  </Button>
                </Grid>
              )}

              {renderRoute(['laundry-module'], permissionUser) && (
                <Grid item>
                  <IconButton
                    variant="contained"
                    component={Link}
                    className={filterStyles.btnAdd}
                    to="/details/laundry/ready"
                  >
                    ITENS DE LAVANDERIA
                  </IconButton>
                </Grid>
              )}

              {!renderRouteRole(['administrador'], role) && (
                <Grid item>
                  <IconButton
                    variant="contained"
                    component={Link}
                    className={filterStyles.btnAdd}
                    to="/details/ready"
                  >
                    OSS PRONTAS PARA ENTREGA
                  </IconButton>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Cards {...props} />
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(Home)
